// extracted by mini-css-extract-plugin
export default {"icon":"Icon_icon__w6Pjo","wrapper":"Icon_wrapper__sRAt-"};